import type {ConnectionOptions, JitsiTrackState} from '../pages/stream/types/lib-jitsi-meet';
import type {StreamingInfo, TStudioMode} from '../pages/stream/types';
import {jwtDecode} from "jwt-decode";

export interface ILayOut {
    gridCol: number;
    gridRow: number;
    studioCol: number;
    studioColSpan: number;
    studioRow: number;
    studioRowSpan: number;
    studioJustifySelf: string;
    localCol: number;
    localColSpan: number;
    localRow: number;
    localRowSpan: number;
    localJustifySelf: string;
    remoteSize: number;
    remoteJustifySelf: string;
}

export const getCellLayout = (sMode: TStudioMode): ILayOut => {
    if (sMode === '6b') {
        return {
            gridCol: 6,
            gridRow: 6,
            studioCol: 1,
            studioColSpan: 6,
            studioRow: 1,
            studioRowSpan: 5,
            studioJustifySelf: 'center',
            localCol: 6,
            localColSpan: 1,
            localRow: 6,
            localRowSpan: 1,
            localJustifySelf: 'center',
            remoteSize: 5,
            remoteJustifySelf: 'center',
        };
    } else if (sMode === '6r') {
        return {
            gridCol: 6,
            gridRow: 6,
            studioCol: 1,
            studioColSpan: 5,
            studioRow: 1,
            studioRowSpan: 6,
            studioJustifySelf: 'center',
            localCol: 6,
            localColSpan: 1,
            localRow: 6,
            localRowSpan: 1,
            localJustifySelf: 'center',
            remoteSize: 5,
            remoteJustifySelf: 'center',
        };
    } else if (sMode === 'pip') {
        return {
            gridCol: 10,
            gridRow: 12,
            studioCol: 1,
            studioColSpan: 12,
            studioRow: 1,
            studioRowSpan: 10,
            studioJustifySelf: 'center',
            localCol: 1,
            localColSpan: 2,
            localRow: 9,
            localRowSpan: 2,
            localJustifySelf: 'center',
            remoteSize: 0,
            remoteJustifySelf: 'center',
        };
    } else if (sMode === '44') {
        return {
            gridCol: 6,
            gridRow: 12,
            studioCol: 4,
            studioColSpan: 6,
            studioRow: 1,
            studioRowSpan: 4,
            studioJustifySelf: 'center',
            localCol: 5,
            localColSpan: 4,
            localRow: 5,
            localRowSpan: 2,
            localJustifySelf: 'center',
            remoteSize: 40,
            remoteJustifySelf: 'center',

            // gridCol: 6,
            // gridRow: 13,
            // studioCol: 4,
            // studioColSpan: 7,
            // studioRow: 1,
            // studioRowSpan: 4,
            // studioJustifySelf: "center",
            // localCol: 6,
            // localColSpan: 3,
            // localRow: 5,
            // localRowSpan: 2,
            // localJustifySelf: "center",
            // remoteSize: 44,
            // remoteJustifySelf: "center",
        };
    } else if (sMode === 'test') {
        return {
            gridCol: 2,
            gridRow: 2,
            studioCol: 1,
            studioColSpan: 1,
            studioRow: 1,
            studioRowSpan: 1,
            studioJustifySelf: 'center',
            localCol: 2,
            localColSpan: 1,
            localRow: 2,
            localRowSpan: 1,
            localJustifySelf: 'center',
            remoteSize: 2,
            remoteJustifySelf: 'center',
        };
    } else if (sMode === 'direct-chat') {
        return {
            gridCol: 12,
            gridRow: 12,
            studioCol: 1,
            studioColSpan: 8,
            studioRow: 3,
            studioRowSpan: 8,
            studioJustifySelf: 'center',
            localCol: 9,
            localColSpan: 4,
            localRow: 5,
            localRowSpan: 4,
            localJustifySelf: 'center',
            remoteSize: 0,
            remoteJustifySelf: 'center',
        };
    } else if (sMode === 'best-perform') {
        return {
            gridCol: 12,
            gridRow: 12,
            studioCol: 1,
            studioColSpan: 12,
            studioRow: 1,
            studioRowSpan: 12,
            studioJustifySelf: 'center',
            localCol: 11,
            localColSpan: 2,
            localRow: 11,
            localRowSpan: 2,
            localJustifySelf: 'center',
            remoteSize: 0,
            remoteJustifySelf: 'center',
        };
    } else if (sMode === 'new-4') {
        return {
            gridCol: 2,
            gridRow: 2,
            studioCol: 2,
            studioColSpan: 1,
            studioRow: 1,
            studioRowSpan: 1,
            studioJustifySelf: 'start',
            localCol: 2,
            localColSpan: 1,
            localRow: 2,
            localRowSpan: 1,
            localJustifySelf: 'start',
            remoteSize: 2,
            remoteJustifySelf: 'end',
        };
    } else if (sMode === 'new-8') {
        return {
            gridCol: 3,
            gridRow: 4,
            studioCol: 2,
            studioColSpan: 2,
            studioRow: 1,
            studioRowSpan: 2,
            studioJustifySelf: 'center',
            localCol: 1,
            localColSpan: 1,
            localRow: 3,
            localRowSpan: 1,
            localJustifySelf: 'center',
            remoteSize: 7,
            remoteJustifySelf: 'center',
        };
    } else if (sMode === 'new-28') {
        return {
            gridCol: 6,
            gridRow: 7,
            studioCol: 3,
            studioColSpan: 3,
            studioRow: 1,
            studioRowSpan: 3,
            studioJustifySelf: 'center',
            localCol: 1,
            localColSpan: 1,
            localRow: 6,
            localRowSpan: 1,
            localJustifySelf: 'center',
            remoteSize: 32,
            remoteJustifySelf: 'center',
        };
    } else if (sMode === 'new-32') {
        return {
            gridCol: 6,
            gridRow: 8,
            studioCol: 3,
            studioColSpan: 4,
            studioRow: 1,
            studioRowSpan: 4,
            studioJustifySelf: 'center',
            localCol: 4,
            localColSpan: 2,
            localRow: 5,
            localRowSpan: 2,
            localJustifySelf: 'center',
            remoteSize: 28,
            remoteJustifySelf: 'center',
        };
    } else if (sMode === 'new-40') {
        return {
            gridCol: 8,
            gridRow: 10,
            studioCol: 3,
            studioColSpan: 6,
            studioRow: 1,
            studioRowSpan: 6,
            studioJustifySelf: 'center',
            localCol: 5,
            localColSpan: 2,
            localRow: 7,
            localRowSpan: 2,
            localJustifySelf: 'center',
            remoteSize: 40,
            remoteJustifySelf: 'center',
        };
    } else if (sMode === 'new-52') {
        return {
            gridCol: 9,
            gridRow: 12,
            studioCol: 4,
            studioColSpan: 6,
            studioRow: 1,
            studioRowSpan: 6,
            studioJustifySelf: 'center',
            localCol: 6,
            localColSpan: 2,
            localRow: 7,
            localRowSpan: 2,
            localJustifySelf: 'center',
            remoteSize: 68,
            remoteJustifySelf: 'center',
        };
    } else {
        return {
            gridCol: 2,
            gridRow: 2,
            studioCol: 2,
            studioColSpan: 1,
            studioRow: 1,
            studioRowSpan: 1,
            studioJustifySelf: 'start',
            localCol: 2,
            localColSpan: 1,
            localRow: 2,
            localRowSpan: 1,
            localJustifySelf: 'start',
            remoteSize: 2,
            remoteJustifySelf: 'end',
        };
    }
};

export const buildOptions = (appId: string, room: string): ConnectionOptions => {
    return {
        hosts: {
            domain: '8x8.vc',
            muc: `conference.${appId}.8x8.vc`,
        },
        serviceUrl: `wss://8x8.vc/${appId}/xmpp-websocket?room=${room}`,
        websocketKeepAliveUrl: `https://8x8.vc/${appId}/_unlock?room=${room}`,
    };
};

export const isVideoPlaying = (videoElement: HTMLVideoElement) => {
    return (
        videoElement &&
        videoElement.readyState >= HTMLMediaElement.HAVE_ENOUGH_DATA &&
        !videoElement.paused &&
        !videoElement.ended &&
        videoElement.currentTime > 0
    );
};

export const isVideoVisiblyDark = (videoElement: HTMLVideoElement) => {
    if (!videoElement || videoElement.videoWidth === 0) return true;
    const canvas = document.createElement('canvas');
    canvas.width = 8;
    canvas.height = 8;
    const context = canvas.getContext('2d');
    if (!context) return false;
    context.drawImage(videoElement, 0, 0, 8, 8);
    const pixels = context.getImageData(0, 0, 8, 8).data;
    let totalBrightness = 0;
    for (let i = 0; i < pixels.length; i += 4) {
        totalBrightness += pixels[i] + pixels[i + 1] + pixels[i + 2];
    }
    const avgBrightness = totalBrightness / (8 * 8 * 3);
    // 카메라 가린 화면도 완전 0이 아니라 미세한 노이즈로 brightness ~7 수준이 나옴.
    // 정상 화면은 100+ 이므로 30을 임계로 잡아 양쪽 다 충분한 마진 확보.
    return avgBrightness < 30;
};

export const isVideoTrackActive = (
    trackState: JitsiTrackState,
    videoElement?: HTMLVideoElement | null
): boolean => {
    if (!trackState.videoTrack) return false;
    if (!videoElement) return false;
    return isVideoPlaying(videoElement) && !isVideoVisiblyDark(videoElement);
};

export const evaluateTrackPriority = (
    trackId: string,
    trackState: JitsiTrackState,
    videoElement?: HTMLVideoElement
): number => {
    let priority = 0;
    if (videoElement) {
        if (videoElement && trackState.videoTrack && isVideoPlaying(videoElement)) {
            priority += 100;
        }
        if (videoElement && trackState.videoTrack && !isVideoVisiblyDark(videoElement)) {
            priority += 50;
        }
    } else {
        // hidden 트랙은 실제 화면 상태를 알 수 없으므로 정상 그리드 셀(150)보다 낮게 책정
        if (trackState.videoTrack) {
            priority += 130;
        }
    }
    if (trackState.audioTrack) {
        priority += 10;
    }
    if (trackState.videoTrack === null) {
        priority -= 200;
    }
    return priority;
};

export const redTeam = [1, 4, 5, 8, 9, 12, 13, 16, 17, 20, 21, 23, 25, 27, 29, 32, 34, 36, 38, 40];
export const blueTeam = [2, 3, 6, 7, 10, 11, 14, 15, 18, 19, 22, 24, 26, 28, 30, 31, 33, 35, 37, 39];

export const getMappingTable = (index: number) => {
    return redTeam.includes(index);
};

export const isBroadcastOver = (streamingData: Array<StreamingInfo>) => {
    const lastStream = streamingData[streamingData.length - 1];
    const now = new Date();
    const one = String(now.getHours()).padStart(2, '0');
    const two = lastStream?.end_time.split(':')[0];
    return one > two;
};

export type TNetworkStatus = '대기' | '나쁨' | '보통' | '좋음';

export const checkNetworkStatus = async (url: string): Promise<TNetworkStatus> => {
    const start = performance.now();
    try {
        const res = await fetch(url, {method: 'HEAD', cache: 'no-cache'});
        const latency = performance.now() - start;

        if (!res.ok) return '나쁨';
        if (latency < 200) return '좋음';
        if (latency < 600) return '보통';
        return '나쁨';
    } catch {
        return '나쁨';
    }
};

// ===== 듀얼 커넥션 모니터링 그리드 (z_monitoring_bot) =====
// 분할/머지는 두 conference 간 안정 식별자인 displayName(경로당명) 기준으로만 한다.
// participantId는 conf마다 새로 발급되어 양쪽이 어긋나므로 절대 분할 키로 쓰지 않는다.
export const MONITOR_BOT_NAME = 'z_monitoring_bot';
export const STUDIO_NAME = '스튜디오';

// 분할에서 제외할 displayName(봇·스튜디오·빈/미상 이름).
const EXCLUDED_SPLIT_NAMES = new Set<string>([MONITOR_BOT_NAME, STUDIO_NAME, '', '-', 'Unknown']);

// 문자열 → 음이 아닌 정수 해시 (Streaming.tsx getStableJitter와 동일 계열의 곱셈 해시).
export function hashString(s: string): number {
    let hash = 0;
    for (let i = 0; i < s.length; i++) {
        hash = (hash * 31 + s.charCodeAt(i)) | 0;
    }
    return hash >>> 0;
}

export function shouldReceiveByName(displayName: string, which: 'own' | 'bot'): boolean {
    if (EXCLUDED_SPLIT_NAMES.has(displayName)) return false;
    const parity = hashString(displayName) % 2;
    return which === 'own' ? parity === 0 : parity === 1;
}

export function mergeRemoteTracksByDisplayName(
    ownMap: Map<string, JitsiTrackState>,
    botMap: Map<string, JitsiTrackState>
): Map<string, JitsiTrackState> {
    const merged = new Map<string, JitsiTrackState>();
    const consider = (state: JitsiTrackState, which: 'own' | 'bot') => {
        const name = state.displayName ?? '';
        if (EXCLUDED_SPLIT_NAMES.has(name)) return;
        if (!shouldReceiveByName(name, which)) return;
        const existing = merged.get(name);
        if (!existing) {
            merged.set(name, state);
            return;
        }
        const existingHasVideo = existing.videoTrack !== null;
        const incomingHasVideo = state.videoTrack !== null;
        if (incomingHasVideo && !existingHasVideo) {
            merged.set(name, state);
        }
    };
    for (const state of ownMap.values()) consider(state, 'own');
    for (const state of botMap.values()) consider(state, 'bot');
    return merged;
}

// localStorage에서 토큰을 로드하되, 만료된 토큰은 null 반환
export const getValidTokenFromStorage = (): string | null => {
    const token = localStorage.getItem('jitsi_token');
    if (!token) return null;
    try {
        const decoded = jwtDecode(token);
        const expTime = (decoded.exp ?? 0) * 1000;
        const timeLeft = expTime - Date.now();
        if (timeLeft > 1000) {
            return token;
        }
        // 만료된 토큰은 삭제
        localStorage.removeItem('jitsi_token');
        return null;
    } catch {
        localStorage.removeItem('jitsi_token');
        return null;
    }
};